export const DATE_RANGE_INPUT_SIZES = ['md', 'lg'] as const;
export type DateRangeInputSize = (typeof DATE_RANGE_INPUT_SIZES)[number];

export const DATE_RANGE_INPUT_PICKER_TRIGGERS = ['modal', 'manual'] as const;
export type DateRangeInputPickerTrigger =
  (typeof DATE_RANGE_INPUT_PICKER_TRIGGERS)[number];

/**
 * Value of a {@link DateRangeInputComponent}. Both endpoints are independently
 * nullable so the control can model a partially-entered range (only `from`,
 * only `to`, or neither). A range with neither endpoint set is normalized to
 * `null`.
 */
export interface DateRangeInputValue {
  from: string | null;
  to: string | null;
}
